import { useThemeHandler } from "@ui/hooks/useThemeHandler"
import { useUiSettings } from "./useUiSettings"

export const useUiThemeHandler = () => {
  const { themeMode } = useUiSettings()
  useThemeHandler(themeMode)
}
